import Odd from "./odd";

const PenaltyShotMarketGroupColumn = ({ markets, cellIndex, rowIndex }) => {
	const odd = markets[cellIndex];

	return <Odd odd={odd} showName={false} />;
};

export default PenaltyShotMarketGroupColumn;
